import RenderManager from "../rendering/render-manager";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElementDynamic from "./base-2d-element-dynamic";
import getTabIndex from "../utils/tab-index";


class TabExplorer extends Base2DElementDynamic {

    get type2d() { return "TabExplorer"; }
    _createContainer() {
        const container = super._createContainer();

        container.classList.add("q3-tab-explorer");

        if (!Q3.editMode) {
            container.classList.add('viewer-button');
            container.tabIndex = getTabIndex();
        }

        return container;
    }

    _initDefaultVars() {
        super._initDefaultVars();

        this._wh = new THREE.Vector2(0, 0).divide(RenderManager.getSize());
        this._content = "";
        this._fontSize = null;
        this._color = null;
        this._background = null;
        this._padding = 10;
        this._paddingX = null;
        this._paddingY = null;
        this._borderWidth = null;
        this._borderRadius = null;
        this._borderColor = null;
        this._resizeable = true;
        this._tabList = [];
        this._activeTab = 0;
        this._tabsEl = [];

    }

    get supportsActions() { return true; }

    get content() { return this._content; }
    set content(val) { this._content = val; }

    get tabList() { return this._tabList; }
    set tabList(val) { this._tabList = val; }

    get activeTab() { return this._activeTab; }
    set activeTab(val) { this._activeTab = val; }

    get fontSize() { return this._fontSize; }
    set fontSize(val) { this._fontSize = val; }
    get color() { return this._color; }
    set color(val) { this._color = val; }
    get background() { return this._background; }
    set background(val) { this._background = val; }
    get padding() { return this._padding; }
    set padding(val) { this._padding = val; }
    get paddingX() { return this._paddingX; }
    set paddingX(val) { this._paddingX = val; }
    get paddingY() { return this._paddingY; }
    set paddingY(val) { this._paddingY = val; }
    get borderWidth() { return this._borderWidth; }
    set borderWidth(val) { this._borderWidth = val; }
    get borderRadius() { return this._borderRadius; }
    set borderRadius(val) { this._borderRadius = val; }
    get borderColor() { return this._borderColor; }
    set borderColor(val) { this._borderColor = val; }
    get resizeable() { return this._resizeable; }
    set resizeable(val) { this._resizeable = val; }

    get currentTab() {
        return this.tabList[this.activeTab]
    }
    get currentTabData() {
        return this.data.tabList[this.activeTab]
    }
    _initValues(options) {
        this.parentLayer.domElement.style.overflow = "visible";

        this._content = "content" in options ? options.content : this._content;
        this._tabList = "tabList" in options ? options.tabList : this._tabList;
        this._activeTab = "activeTab" in options ? options.activeTab : this._activeTab;

        /* SPECIFIC 2D ELEMENTS PARAMETERS */
        this._fontSize = "fontSize" in options ? options.fontSize : this._fontSize;
        // this._color = "color" in options ? options.color : this._color;
        // this._background = "background" in options ? options.background : this._background;
        this._color = "#fff";
        this._background = "#0D0B1C";
        this._padding = "padding" in options ? options.padding : this._padding;
        this._paddingX = "paddingX" in options ? options.paddingX : null;
        this._paddingY = "paddingY" in options ? options.paddingY : null;
        this._borderWidth = "borderWidth" in options ? options.borderWidth : this._borderWidth;
        this._borderRadius = "borderRadius" in options ? options.borderRadius : this._borderRadius;
        this._borderColor = "borderColor" in options ? options.borderColor : this._borderColor;
        this._resizeable = "resizeable" in options ? options.resizeable : this._resizeable;

        this._sizeSm = options.sizeSm ? options.sizeSm : {
            x: 0.05,
            y: 0.05,
            fontSize: this._fontSize,
            width: 0.67,
            height: 0.78,
        };
        this._sizeLg = options.sizeLg ? options.sizeLg : {
            x: 0.15,
            y: 0.15,
            fontSize: this._fontSize,
            width: 0.7,
            height: 0.8,
        };

    }

    constructor(options, parentLayer, uuid) {

        super(options, parentLayer, uuid);

        this.Proxy = new Proxy(this,{
            get(target, property){
                console.log(`Property ${property} has been read.`);
                return target[property];
            },
            set(target, property, value) {
                target[property] = value;
                console.log(`Property ${property} has been set.`);
                return true;
            }
        })

        if (options.tabList.length) this.drawTabs();

        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            })
        }


        if (Q3.editMode) {
            this.domElement.addEventListener('click', e => {
                if (e.target.classList.contains("tab-label") || e.target.parentElement.classList.contains("tab-label")) {
                    return;
                }
                this.selectHandler(e);
            }, false);
        }

        this.redraw = this.redraw.bind(this);

        this.handleListeners(true);

        this.redraw();
        this.drawTabs();
        this.setActiveTab(0);

    }

    redraw(width, height) {

        !width && (width = RenderManager.domElement.width / RenderManager.pixelRatio);
        !height && (height = (RenderManager.domElement.height) / RenderManager.pixelRatio);

        if (!Q3.editMode) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            if (this.resizeable) {
                Object.assign(this, this[currentSize]);
            } else {
                Object.assign(this, { x: this[currentSize].x, y: this[currentSize].y, fontSize: this[currentSize].fontSize });
            }
        }

        let padding = this.resizeable ? 0 : `${(0.15 + 0.055 * (this.paddingY ? this.paddingY : this.padding)) + "em"} ${(0.25 + 0.175 * (this.paddingX ? this.paddingX : this.padding)) + "em"}`
        let style = {
            fontSize: this.fontSize / 24 + "rem",
            color: this.color,
            padding: padding,
        };

        if (Q3.editMode) {
            if (Q3.mobileView && this.hiddenMobile) {
                this.domElement.style.opacity = 0.4;
            } else if (!Q3.mobileView && this.hiddenDesktop) {
                this.domElement.style.opacity = 0.4;
            } else {
                this.domElement.style.opacity = 1;
            }
        }

        Object.assign(this.domElement.style, style);

        let [x, y] = this._calcPosition(width, height);
        let w,h;
        if (this.resizeable) {
          let pos = this.getRenderPositionAndSize(width, height);
          [x, y, w, h] = [pos.x, pos.y, pos.w, pos.h];
          this.domElement.style.width = w + "px";
          this.domElement.style.height = h + "px";
        } else {
            this.domElement.style.removeProperty("width");
            this.domElement.style.removeProperty("height");
        }
        this.domElement.style.position = "absolute";
        this.domElement.style.top = Math.round(y) + "px";
        this.domElement.style.left = Math.round(x) + "px";
        if (Q3.editMode) {
        this.domElement.classList[(Q3.selected === this && !Q3.multiSelect[this.uuid]) ? "add" : "remove"]("is-selected")
        }
        if (this.objChanged) {
            Events.fire("objchanged");
            this.objChanged = false;
        }
    }


    drawTabs() {
        this.domElement.innerHTML = "";
        var tabs = document.createElement('div');
        this.content = document.createElement('div')
        tabs.setAttribute('class', 'tab-list');
        this.content.setAttribute('class', 'tab-content');
        this.tabList && this.tabList.map((item, index)=> {
            var newTab = this.tabElement(item);
            newTab.addEventListener("click", () => {
                this.setActiveTab($(newTab).index());
            });
            tabs.appendChild(newTab);
        });
        this._tabsEl = tabs;
        if (Q3.editMode) {
            Sortable.create(tabs, {
                handle: ".tab-label",
                animation: 200,
                easing: "cubic-bezier(1, 0, 0, 1)",
                direction: 'horizontal',
                onEnd: (evt) => {
                    let tablist = this.tabList;
                    let tab =tablist[evt.oldIndex];
                    tablist.splice(evt.oldIndex, 1);
                    tablist.splice(evt.newIndex, 0, tab);
                    this.tabList = tablist;
                    this.data.tabList = tablist;

                },
            });
        }
        this.domElement.appendChild(tabs);
        this.domElement.appendChild(this.content);
    }

    removeTab() {
        this._tabsEl.removeChild(this._tabsEl.childNodes[this.activeTab]);
    }

    addTab() {
        this._tabsEl.append(this.tabElement(this.tabList[this.tabList.length-1]));
    }

    setActiveTab(index) {
        //this.activeTab = index;
        this.Proxy.activeTab = index;
        let currentSelection = this._tabsEl.getElementsByClassName("selected")[0];
        currentSelection && currentSelection.classList.remove("selected");
        this._tabsEl.children[this.activeTab].classList.add("selected");
        this.updateTabContent()
        if(Q3.editMode) {
            $('.note-editable').html(this.content.innerHTML);
        }
    }

    tabElement(tab) {
        var labelDiv = document.createElement('div');
        labelDiv.setAttribute('class', 'tab-label');
        labelDiv.innerHTML = `${tab.label}`;
        labelDiv.style.backgroundColor = tab.background;
        labelDiv.style.color = tab.color;
        return labelDiv;
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    hide() {

        this.textElement.classList.add('2d-element-hidden');

    }

    show() {
        this.textElement.classList.remove('2d-element-hidden');
    }

    hexToRgba(hex, alpha) {
        let c = new THREE.Color(hex).toArray();
        return "rgba(" + c[0] * 255 + "," + c[1] * 255 + "," + c[2] * 255 + "," + alpha + ")";
    }

    getBBox() {
        const bbox = this.domElement.getBoundingClientRect();

        let x, y;

        if (!Q3.editMode) {
            x = this.position * 100;
            y = this.position * 100;
        }

        return { x, y, w: bbox.width + x, h: bbox.height + y };
    }

    setLabelText(text, index) {
        this.tabList[index].label = text;
        let label = this.domElement.querySelectorAll('.tab-label')[index];
        label.innerHTML = `${text}`;
        Events.fire("objchanged");
    }

    updateTabContent() {
        this.content.innerHTML = this.currentTab.content;

        if (this.currentTab.fontSize) {
            this.content.style.fontSize = parseFloat(this.currentTab.fontSize) / 24 + "rem"
        }
        [
            {key: "lineHeight", prop: "line-height" },
            {key: "background", prop: "background"},
            {key: "color", prop: "color"}
        ].forEach((s) => {
            if (this.currentTab[s.key]) {
                this.content.style[s.prop] = this.currentTab[s.key];
            } else {
                this.content.style.removeProperty(s.prop);
            }
        })
    }

    setBackColor(color, index) {
        let label = this.domElement.querySelectorAll('.tab-label')[index];
        label.style.backgroundColor = color;
        this.content.style.background = color;
        Events.fire("objchanged");
    }

    setFontColor(color, index) {
        let label = this.domElement.querySelectorAll('.tab-label')[index];
        label.style.color = color;
        this.content.style.color= color;
        Events.fire("objchanged");
    }

    getRenderPositionAndSize(width, height) {
        const size = RenderManager.getSize();

        if (!width) { width = size.width; }
        if (!height) { height = size.height; }

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let w = this.width * width * RenderManager.pixelRatio;
        let h = this.height * height * RenderManager.pixelRatio;

        // if (w < 80) { w = 80; }
        // if (h < 40) { h = 40; }

        const [x, y] = this._calcPosition(width, height);

        return { x, y, w, h };
    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {
        //Rewrite

        const tab = new TabExplorer({
            content: this.content,
            x: this.x + 0.01,
            y: this.y + 0.01,
        },
            this.parentLayer,
            THREE.Math.generateUUID()
        );

        Q3.data.layers.layers2D[tab.parentLayer.uuid].objects[tab.uuid] = {
            type: 'text',
            content: tab.content,
            x: tab.x,
            y: tab.y,
        };

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 0, tab);

        return tab;

    }

    setData(data) {
        if (!this.resizeable) {
            delete data.width;
            delete data.height;
        }
        let currentSize = this.getVWSize();

        Object.assign(this[currentSize], data);

        const object = this.data;

        if (!object[currentSize]) { object[currentSize] = {}; }

        Object.assign(object[currentSize], data);

        this.redraw();
    }

    setProxyHandler(handler) {
        Object.keys(handler).forEach(key => {
            const value = handler[key];
            if (Reflect[key] && typeof value !== 'function') {
              throw new Error(`Trap "${key}: ${value}" is not a function`);
            }
        });
        this.Proxy = new Proxy(this,handler); 
    }

    get width() {
        return this.resizeable ? this._wh.x : this.domElement.offsetWidth / Q3.container.offsetWidth;
    }

    set width(val) {
        this._wh.x = val;
    }

    get height() {
        return this.resizeable ? this._wh.y : this.domElement.offsetHeight / Q3.container.offsetHeight;
    }

    set height(val) {
        this._wh.y = val;
    }
}

export default TabExplorer;
export { TabExplorer };
